import {useMutation, UseMutationResult} from "react-query";
import {API, CustomAxiosError} from "../../../../logics/api-config";


const useApiUpdateMonthlyInvoice = (): UseMutationResult<void, CustomAxiosError, {
    id: number,
    data: any
}, unknown> => {
    return useMutation<void, CustomAxiosError, { id: number; data: any }>(
        async ({id, data}) => {
            console.log('data', data)
            try {
                console.log(data)
                await API.put(`/accounting/bills/monthly/${id}`, data);
            } catch (error) {
                throw error;
            }
        }
    );
};

export default useApiUpdateMonthlyInvoice;
